<template>
    <nav class="flex" aria-label="Breadcrumb">
        <ol role="list" class="flex space-x-4 rounded-md bg-white px-6 shadow">
            <li class="flex">
                <div class="flex items-center">
                    <a
                        :href="route('reports.index')"
                        class="text-gray-400 hover:text-gray-500"
                    >
                        <HomeIcon class="h-5 w-5 shrink-0" aria-hidden="true" />
                        <span class="sr-only">{{ $t("vue.home") }}</span>
                    </a>
                </div>
            </li>
            <li class="flex">
                <div class="flex items-center">
                    <svg
                        class="h-full w-6 shrink-0 text-gray-200"
                        viewBox="0 0 24 44"
                        preserveAspectRatio="none"
                        fill="currentColor"
                        aria-hidden="true"
                    >
                        <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" />
                    </svg>
                    <a
                        :href="
                            route('reports.show', {
                                domain: domain,
                            })
                        "
                        class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                        >{{ domain }}</a
                    >
                </div>
            </li>
            <li v-if="source" class="flex">
                <div class="flex items-center">
                    <svg
                        class="h-full w-6 shrink-0 text-gray-200"
                        viewBox="0 0 24 44"
                        preserveAspectRatio="none"
                        fill="currentColor"
                        aria-hidden="true"
                    >
                        <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" />
                    </svg>
                    <a
                        :href="
                            route('reports.show.source', {
                                domain: domain,
                                source: source,
                            })
                        "
                        class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                        >{{ source }}</a
                    >
                </div>
            </li>
            <li v-if="ip" class="flex">
                <div class="flex items-center">
                    <svg
                        class="h-full w-6 shrink-0 text-gray-200"
                        viewBox="0 0 24 44"
                        preserveAspectRatio="none"
                        fill="currentColor"
                        aria-hidden="true"
                    >
                        <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" />
                    </svg>
                    <a
                        :href="
                            route('reports.show.ip', {
                                domain: domain,
                                source: source,
                                ip: ip,
                            })
                        "
                        class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                        >{{ ip }}</a
                    >
                </div>
            </li>
        </ol>
    </nav>
</template>

<script lang="ts" setup>
import { defineProps } from "vue";
import route from "ziggy-js";
import { HomeIcon } from "@heroicons/vue/20/solid";

defineProps<{
    domain: string;
    source: string | null;
    ip: string | null;
}>();
</script>
